import BaseModal from './BaseModal';
import s from './BaseModal.module.css';
import l from './LoginModal.module.css';
import { useHistory } from 'react-router-dom';

const PurchaseModal = ({onClose}) => {
    const history = useHistory();
    const goToUpgrade = () => {
        // Redirect to login page
        history.push('/upgrade');
    }
    return ( 
        <BaseModal height="20rem"onClose={onClose}>
            <div className={l.loginModalContainer}>
                <div className={l.title}>
                    Ready to save and export contacts?
                </div>
                <div className={l.subtitle}>
                    Upgrade to a plan <br />&<br /> join other industry leaders across dozens of verticals.
                </div>
                <div className={`${s.blackButton} ${l.button}`} onClick={goToUpgrade}>OK</div>
            </div>
        </BaseModal>
     );
}
 
export default PurchaseModal;